import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parent',
  templateUrl: './parent.component.html',
  styleUrls: ['./parent.component.scss']
})
export class ParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

    //TODO: Tipar o res
    showMessage(res, messageService) {
      let severity: string = 'success';
      let messages = res.messages;
      let summary: string = "Sucesso";
      if(res.status == 404) {
        severity = 'warn';
        summary = "Alerta";
        messages = res.error.messages;
      } else if (res.status != 200) {
        severity = 'error';
        summary = "Atenção";
        messages = res.error.messages;
      }
  
      messages.forEach(msg => {
        messageService.add({severity, summary, detail: msg.text});
      });
    }
  
}
